export default __webpack_public_path__ + "static/media/34.1ec4af25.jpg";